/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateLocationDto interface.
 */
export function instanceOfCreateLocationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function CreateLocationDtoFromJSON(json) {
    return CreateLocationDtoFromJSONTyped(json, false);
}
export function CreateLocationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function CreateLocationDtoToJSON(json) {
    return CreateLocationDtoToJSONTyped(json, false);
}
export function CreateLocationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
    };
}
//# sourceMappingURL=CreateLocationDto.js.map